'use client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Slider, { Settings } from 'react-slick';

import NextArrow from './NextArrow';
import PrevArrow from './PrevArrow';

import './style.css';

import AlgoliaProductCard from '@/components/V2/ProductCard/AlgoliaProductCard';
import { AlgoliaProduct } from '@/types/Algolia';

// export type CarouselItems = Array<ProductCardProps & { key: string }>;
// type CardSize = Pick<ProductCardProps, 'size'>;
export interface ProductCarouselProps {
  products: AlgoliaProduct[];
  animation?: 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out';
  autoPlay?: boolean;
  pauseOnHover?: boolean;
  infinite?: boolean;
  speed?: number;
  swipeToSlide?: boolean;
  showQualifyingBadge?: boolean;
  queryID?: string;
  isBackOffice?: boolean;
}

export default function AlgoliaProductCarousel({
  products,
  showQualifyingBadge,
  animation = 'ease',
  autoPlay = false,
  pauseOnHover = true,
  infinite = false,
  swipeToSlide = false,
  speed = 500,
  queryID,
  isBackOffice,
}: ProductCarouselProps) {
  // const ProductsCount = isBackOffice ? 4 : 3;
  const ProductsCount = 3;
  const slidesToShowProducts = products.length >= 4 ? ProductsCount : products.length;

  const settings: Settings = {
    slidesToShow: slidesToShowProducts,
    slidesToScroll: 1,
    speed,
    infinite,
    pauseOnHover,
    swipeToSlide,
    autoplay: autoPlay,
    cssEase: animation,
    className: `product-slider ${products.length < 3 && 'algolia-product-slider'}`,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowProducts,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="max-w-full">
      <Slider {...settings}>
        {products?.map((product, idx) => (
          <div key={product.objectID}>
            <AlgoliaProductCard
              product={product}
              queryID={product?.__autocomplete_queryID || queryID || ''}
              index={idx + 1}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
